export default "__VITE_ASSET__rqVsxhMy__"